import React from 'react';
import Browse from './Browse';

const Vendors = props => <Browse pageType="vendors" {...props} />;

export default Vendors;
